import React, { Component } from "react";
import { reduxForm, Field } from "redux-form";
import FormInput from "../../Components/FormInput/FormInput";
import Button from "Components/Button";
import LoadingIcon from "../../Components/LoadingIcon";

const validate = values => {
  const errors = {};
  if (!values.password) {
    errors.password = "Required";
  }
  if (values.confirm_password !== values.password) {
    errors.confirm_password = "Passwords must match";
  }
  return errors;
};

class PasswordResetForm extends Component {
  render() {
    const { handleSubmit, fetching } = this.props;
    return (
      <form onSubmit={handleSubmit}>
        <div className={"fgt-pwd-input"}>
          <Field
            name={"password"}
            component={FormInput}
            placeholder={"Insert your password"}
            type={"password"}
          />
        </div>
        <div className={"fgt-pwd-input"}>
          <Field
            name={"confirm_password"}
            component={FormInput}
            placeholder={"Confirm password"}
            type={"password"}
          />
        </div>
        <div className={"fgt-pwd-button"}>
          <Button type={"submit"}>
            {fetching ? <LoadingIcon /> : "Reset Password"}
          </Button>
        </div>
      </form>
    );
  }
}

PasswordResetForm = reduxForm({
  form: "PasswordResetForm",
  validate
})(PasswordResetForm);

export default PasswordResetForm;
